import React, { useState } from 'react';
import MarketingPageLayout from '../Welcome/MarketingPageLayout';
import GenerateInvoice from '../payment/GenerateInvoice';
import CouponInput from './CouponInput';

const Upgrade = () => {
  const [isButton, setIsButton] = useState<boolean>(true);

  return (
    <MarketingPageLayout navVariant="legacy">
      <section className="bg-light py-4">
        <div className="container">
          <div className="text-center bg-white p-4 rounded shadow-sm">
            <h1 className="text-primary">Grow Your Family Legacy</h1>
            <p className="text-muted mt-4">
              Unlock unlimited possibilities, exclusive features, and seamless collaboration with your family.
            </p>
            <p className="text-muted">Ready to build and preserve your family&apos;s history? Upgrade now!</p>
            {isButton && (
              <button
                type="button"
                className="btn btn-success mt-5"
                onClick={() => setIsButton(false)}
              >
                Upgrade to iGiTREE Premium
              </button>
            )}
            {!isButton && <GenerateInvoice />}
            <CouponInput />
          </div>
        </div>
      </section>
    </MarketingPageLayout>
  );
};

export default Upgrade;
